import {connect} from 'react-redux';

import {getConfig} from 'mattermost-redux/selectors/entities/general';
import {getPost} from 'mattermost-redux/selectors/entities/posts';

import {type Post} from 'mattermost-redux/types/posts';

import {getIsMobileView} from 'selectors/views/browser';

import {type GlobalState} from 'types/store';
import {type FilePreviewComponent} from 'types/store/plugins';

import {canDownloadFiles} from 'utils/file_utils';

import FilePreviewModal from './file_preview_modal';

type OwnProps = {
    post?: Post;
    postId?: string;
}

function mapStateToProps(state: GlobalState, ownProps: OwnProps) {
    const config = getConfig(state);

    return {
        canDownloadFiles: canDownloadFiles(config),
        enablePublicLink: config.EnablePublicLink === 'true',
        isMobileView: getIsMobileView(state),
        pluginFilePreviewComponents: state.plugins.components.FilePreview as unknown as FilePreviewComponent[],
        post: ownProps.post || getPost(state, ownProps.postId || ''),
        siteUrl: config.SiteURL,
    };
}

export default connect(mapStateToProps)(FilePreviewModal);
